import p5 from 'p5';
import { marbleFallsSketch } from './sketch';

new p5(marbleFallsSketch);
